import r from "react";
import { Spinner as c } from "../../../Spinner/Spinner.js";
import { ChevronUp as m, ChevronDown as p } from "@olxbr/ds-icons";
var o = Object.getOwnPropertySymbols,
  u = Object.prototype.hasOwnProperty,
  f = Object.prototype.propertyIsEnumerable,
  v = (t, a) => {
    var l = {};
    for (var e in t) u.call(t, e) && a.indexOf(e) < 0 && (l[e] = t[e]);
    if (t != null && o) for (var e of o(t)) a.indexOf(e) < 0 && f.call(t, e) && (l[e] = t[e]);
    return l;
  };
const i = t => {
  var a = t,
    {
      state: l,
      isOpen: e
    } = a,
    s = v(a, ["state", "isOpen"]),
    n;
  return l === "loading" ? r.createElement("span", {
    className: "olx-multiselect__icon-right"
  }, r.createElement(c, {
    "aria-label": (n = s["aria-label"]) != null ? n : "",
    size: "extra-small"
  })) : e ? r.createElement("span", {
    className: "olx-multiselect__icon-right"
  }, r.createElement(m, null)) : r.createElement("span", {
    className: "olx-multiselect__icon-right"
  }, r.createElement(p, null));
};
i.displayName = "IconRight";
export { i as IconRight };